module.exports = __webpack_public_path__ + "img/no-permissions.62dd2a21.png";